import { BookOpen, FileText, Users } from "lucide-react";

const BENEFITS = [
  {
    icon: FileText,
    text: "A detailed exam page with format, cost, what the test covers, and a study roadmap",
  },
  {
    icon: Users,
    text: "Study groups people can create and join for this exam",
  },
  {
    icon: BookOpen,
    text: "It appears in search so others can find it, plus a community of people preparing for the same exam",
  },
];

export function SuggestCertRequestExplainer({
  certName,
}: {
  certName?: string;
}) {
  const named = certName?.trim();

  return (
    <div className="mb-6">
      <p className="text-sm text-gray-500">
        {named ? (
          <>
            Request{" "}
            <span className="font-medium text-gray-800">&ldquo;{named}&rdquo;</span>{" "}
            and we&apos;ll review adding it to CertLynx. Once it&apos;s approved:
          </>
        ) : (
          <>
            Request it and we&apos;ll review adding it to CertLynx. Once
            it&apos;s approved:
          </>
        )}
      </p>
      <ul className="mt-3 space-y-2.5">
        {BENEFITS.map(({ icon: Icon, text }) => (
          <li key={text} className="flex items-start gap-2.5 text-sm text-gray-700">
            <span className="h-8 w-8 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
              <Icon className="h-4 w-4 text-blue-600" />
            </span>
            <span className="pt-1.5 leading-snug">{text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
